// extracted by mini-css-extract-plugin
export default {"infoHolder":"infoHolder__I8lh6","infoHolderIcon":"infoHolderIcon__XCJrk","popover":"popover__sQ1fC","text":"text__Vxamn","arrow":"arrow__cf_Bq","hidden":"hidden__bmQAC"};